import './components/mobile.icon';
import accountActionModal from './components/accountActionModal';
import { publish, subscribe } from '@wh/message-bus';
import { bootstrap } from './bootstrap';
import { config } from './config';
import { getLastSiteVisited, getNuiCode, redirectToLastVisitedSite, createCloseButton } from './utils';
import { DEFAULT_PROMO, TOPICS, LOGGED_IN_STATE } from './constants';
import '../css/styles.css';
import './slider';

let REDIRECT_FLAG = false;
let BOOTSTRAP_READY = false;

// CONTROLS
const joinButton = document.querySelector('#join-button');
const loginButton = document.querySelector('#login-button');
const registrationCTAs = document.querySelectorAll('[data-vertical]');
const spinnerOverlay = document.querySelector('#spinner-overlay');

// LISTENERS
window.addEventListener('load', main);

loginButton.addEventListener('click', async () => {
  REDIRECT_FLAG = true;

  await bootstrapReady({ spinner: true });
  publish(TOPICS.LOGIN_START);
});

joinButton.addEventListener('click', async () => {
  REDIRECT_FLAG = false;

  await bootstrapReady({ spinner: true });
  publish(TOPICS.REGISTRATION_START, {
    nui: DEFAULT_PROMO,
  });
});

registrationCTAs.forEach((el) =>
  el.addEventListener('click', async ({ currentTarget: { dataset } }) => {
    await bootstrapReady({ spinner: true });

    const payload =
      dataset.vertical === 'sports'
        ? {
            nui: DEFAULT_PROMO,
          }
        : {};

    publish(TOPICS.REGISTRATION_START, payload);
  })
);

// HANDLERS
async function main() {
  const features = await bootstrap();

  const hash = window.location.hash;

  if (hash.startsWith('#!/action/register')) {
    features['registration-flow'].start({ nui: getNuiCode(hash) });
  }

  import('./analytics')
    .then(() => {
      console.info('[SPLASH]: analytics loaded successfully!');
    })
    .catch(console.error);

  subscribe('wh.common.event.session.logIn', (_, { state }) => {
    if (state === LOGGED_IN_STATE && REDIRECT_FLAG) {
      spinnerOverlay.style = 'display: flex;';
      features['obsession-service'].awaitLoggedIn().then(() => {
        spinnerOverlay.style = 'display: none;';
        window.location.href = getLastSiteVisited(config.redirect_fallback);
      });
    }
  });

  features['account-actions'].onActionRequested((actionPayload) => handleAccountAction(features, actionPayload));
}

function handleAccountAction(features, { actionId, data }) {
  switch (actionId) {
    case TOPICS.AA_REGISTRATION_START: {
      features['registration-flow'].start({ nui: DEFAULT_PROMO });
      break;
    }
    case TOPICS.AA_DEPOSIT_START: {
      if (data) {
        spinnerOverlay.style = 'display: flex;';
        features['obsession-service'].awaitLoggedIn().then(() => {
          spinnerOverlay.style = 'display: none;';
          accountActionModal({
            url: data,
            onClose: () => redirectToLastVisitedSite(config.redirect_fallback),
            closeEventListenerType: 'message',
            outfit: 'full-width',
          });
        });
      }
      break;
    }
    case TOPICS.AA_ACCOUNT_RECOVERY:
    case TOPICS.AA_ACCOUNT_REOPEN: {
      accountActionModal({
        url: data,
        closeEventListenerType: 'click',
        closeEventListenerElement: createCloseButton(),
      });
      break;
    }
    case TOPICS.AA_LOGIN_START: {
      features['login-flow'].start();
      break;
    }
    case TOPICS.AA_DCF: {
      features['decouple-card-flow'].start();
      break;
    }
    case TOPICS.AA_HARD_FLAG:
    case TOPICS.AA_SOFT_FLAG: {
      features['account-flags-flow'].start(data);
      break;
    }

    case TOPICS.AA_PASSWORD_RESET: {
      accountActionModal({
        url: data,
        closeEventListenerType: 'click',
        closeEventListenerElement: createCloseButton(),
        outfit: 'full-width',
      });
      break;
    }

    case TOPICS.AA_FAQ_PAGE_OPEN: {
      window.open(data);
      break;
    }

    default:
      break;
  }
}

// SUBSCRIPTIONS
subscribe(TOPICS.REGISTRATION_START, () => {
  REDIRECT_FLAG = false;
});

async function bootstrapReady({ spinner = false }) {
  if (BOOTSTRAP_READY) {
    return Promise.resolve();
  }

  if (spinner) {
    spinnerOverlay.style = 'display: flex;';
  }

  return new Promise((resolve) =>
    subscribe(TOPICS.SESSION_STATE_GET, () => {
      BOOTSTRAP_READY = true;

      if (spinner) {
        spinnerOverlay.style = 'display: none;';
      }

      resolve();
    })
  );
}

bootstrapReady({ spinner: false });
